export function enableBlurBackdrop() {
    const backdrops = document.getElementsByClassName('modal-backdrop');
    if (backdrops.length >= 1) {
        backdrops[0].classList.add('modal-backdrop--blur');
    }
}